var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-0 mb-5"},[_vm._v("Orders")]),_vm._v(" "),_c('order-list'),_vm._v(" "),_c('ux-btn',{attrs:{"color":"outline-primary","to":"/profile"}},[_vm._v("Back to Profile")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }